module.exports = __webpack_public_path__ + "static/media/file.5f6a2147.png";